





















































































import { defineComponent, reactive, ref } from '@vue/composition-api'
import Layout from '../organisms/common/Layout.vue'
import { updatePassword } from '../../api/users'
import { PasswordSettingParam } from '../../types/user'

export default defineComponent({
  name: 'PasswordSetting',
  components: { Layout },
  setup(props, context) {
    const model = reactive({
      password: '',
      verifiedPassword: '',
    })
    const query = reactive({
      code: String(context.root.$route.query.code),
      token: String(context.root.$route.query.token),
    })
    const loading = ref(false)
    const failed = ref(false)
    const changed = ref(false)
    const form = ref<HTMLFormElement>()
    const validate = () => {
      if (!form.value) {
        return false
      }
      return form.value?.validate()
    }
    const passwordRules = [
      (v: any) => !!v || 'パスワードは必須項目です。',
      (v: any) =>
        (v && v.length <= 32) || 'パスワードは32文字以内で入力してください。',
    ]
    const verifiedPasswordRules = [
      (v: string) => v === model.password || '確認用パスワードが一致しません',
    ]

    const changePassword = async () => {
      if (!validate()) {
        return
      }
      loading.value = true
      try {
        if (!validate()) {
          throw new Error()
        }
        const passwordSettingParam: PasswordSettingParam = {
          code: query.code,
          password: model.password,
          passwordResetToken: query.token,
        }
        await updatePassword(passwordSettingParam)
        loading.value = false
        changed.value = true
      } catch (error) {
        failed.value = true
        loading.value = false
      }
    }
    const toLogin = () => {
      context.root.$router
        .push({
          path: '/login',
        })
        .catch(() => {
          /*2連打した際のerrorを無視*/
        })
    }

    return {
      model,
      loading,
      query,
      changed,
      form,
      passwordRules,
      verifiedPasswordRules,
      changePassword,
      failed,
      toLogin,
    }
  },
})
